import { authUrl, baseUrl } from '@/api/types';

export function loginUrl() {
  return `${authUrl}/login`;
}

export function registerGoogleValidationUrl() {
  return `${authUrl}/register-google-validation`;
}

export function loginGoogleUrl() {
  return `${authUrl}/login-google`;
}

export function registerUrl() {
  return `${authUrl}/register`;
}

export function remindUrl() {
  return `${authUrl}/remind`;
}

export function resetUrl() {
  return `${authUrl}/reset`;
}

export function logoutUrl() {
  return '/auth/logout';
}

export function parseLocalRedirectUrl() {
  return '/parse-local-redirect';
}

export function userConfirmEmailEditUrl() {
  return `${authUrl}/user-email-edit`;
}

export function userConfirmEmailResendUrl() {
  return `${authUrl}/user-email-confirm-resend`;
}

export function userConfirmEmailCodeUrl() {
  return `${authUrl}/user-email-confirm`;
}

export function userDevModePreviewUrl() {
  return `${authUrl}/development-preview`;
}

export function userChangeLanguageUrl() {
  return `${authUrl}/user-language`;
}

export function changeLocaleUrl(locale) {
  return `/change-locale/${locale}`;
}

export function smartIdAuthInitUrl() {
  return `${baseUrl}/smart-id/init`;
}

export function smartIdAuthUrl() {
  return `${baseUrl}/smart-id/auth`;
}

export function smartIdSetupUrl() {
  return `${baseUrl}/smart-id/setup`;
}

export function onboardingCompanyV3Url() {
  return `${baseUrl}/onboarding-company-v3`;
}

export function onboardingCompanyV3CreateUrl() {
  return `${onboardingCompanyV3Url()}/create`;
}

export function onboardingCompanyV3StoreUrl() {
  return `${onboardingCompanyV3Url()}`;
}
